/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';
import { OrgProfileField } from '../models/account-fields';

export const OrgFieldsSchema = new schema.Entity<OrgProfileField>(
  'orgProfileFields',
);
